import React from 'react';
import { Button } from 'reactstrap';
import Layout from '../components/layout';

let list = [{
    color: 'text-red',
    title: 'PURIFY',
    subTitle: 'Cleanse',
    content: 'Our skin is our largest organ, and it\'s also our most exposed. Just walking down the street causes dirt and debris to accumulate in our pores. We use all natural cleansers with powerful active ingredients and essential oils.'
}, {
    color: 'text-primary',
    title: 'detox',
    subTitle: 'Tone',
    content: 'We double cleanse for maximum effect, using a tonner to detoxify and clear out any lingering impurities and oils on the skin.'
}, {
    color: 'text-primary-dark',
    title: 'polish',
    subTitle: 'Exfoliate',
    content: 'Using only natural rice husks applied gently by hand, dead skin cells are scrubbed away, leaving skin soft and smooth for a brightened, refreshed face.'
}, {
    color: 'text-teal',
    title: 'soothe',
    subTitle: 'Massage',
    content: 'We calm skin after exfoliation using effleurage and classic massage techniques.  This stimulates the skin and facial muscles, activating their regenerative properties.'
}, {
    color: 'text-blue',
    title: 'repair',
    subTitle: 'Mask',
    content: 'Each mask is customized to your skin type and mixed fresh by our professionals, combining essential botanicals, herbs, fruits, and oils to nourish your face with the vitamins and minerals it specifically needs.  It provides hydration and balance through the use of holistic remedies, creating even, radiant skin for all skin types and conditions.'
}];

const boxes = list.map((data, key) =>
    <div className='info-box' key={data.title}>
        <p className={`mb-1 ${data.color}`}>{key + 1}</p>
        <h4 className={`mb-1 ${data.color}`}>{data.title}</h4>
        <p className='font-weight-bold font-regular'>{data.subTitle}</p>
        <p className='font-small line-height-24'>{data.content}</p>
    </div>
);

const Process = () => (
    <Layout>
        <main className='process mt-5'>
            <section className='banner container'>
                <h2 className='text-center px-3'>Treatment process</h2>
                <p className='text-center px-5 mt-4'>Glow inside and out. Our 5-step treatment uses all natural, organic and plant-based ingredients and includes a freshly mixed mask personalized to your skin type.</p>
                <div className='d-flex flex-row flex-wrap justify-content-center mt-4'>
                    {boxes}
                </div>
            </section>

            {/* pure Section */}
            <section className='active-ingredients mt-5'>
                <div className="container">
                    <div className='row align-items-center text-cntr'>
                        <div className='offset-md-1 col-md-4'>
                            <div className="display-1">pure</div>
                            <h4>ingredients</h4>
                            <p className='mt-4 font-small line-height-24'>Give your skin good food.  With active ingredients like cucumber, papaya, and rosewater, our facial is like a jice cleanse for your face.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* look good Section */}
            <section className='look-good-cntr'>
                <div className='d-flex flex-column align-items-center look-good'>
                    <h1 className='text-uppercase'><span>look good,</span> <span>feel good.</span></h1>
                    <div className="book-facial-btn">
                        <Button outline color="primary" size="lg" className='text-uppercase'>BOOK YOUR ORGANIC FACIALS</Button>
                    </div>
                </div>
            </section>

            {/* citrus Section */}
            <section className='book-facial'></section>
        </main>
    </Layout>
)

export default Process
